import {
    ActionIcon,
    Box,
    Group,
    Paper,
    TextInput,
    Button,
    Text,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import { X, Plus } from "tabler-icons-react";

function WordByWordTranscriptionForm({ form, index }) {
    const [words, setWords] = useState([]);

    // Initialize words from form data if editing
    useEffect(() => {
        const existingWords = form.values.epreuves[index]?.words || [];
        const correctionDp = form.values.epreuves[index]?.correction_dp || [];
        const consigne = form.values.epreuves[index]?.consigne || [];

        // If we have existing words, use them
        if (existingWords.length > 0) {
            setWords(existingWords);
        }
        // If we have correction_dp data (from editing), create words from it
        else if (correctionDp.length > 0) {
            const wordsFromData = correctionDp.map((word, wordIndex) => ({
                id: Date.now() + wordIndex,
                target: word,
            }));
            setWords(wordsFromData);
            form.setFieldValue(`epreuves.${index}.words`, wordsFromData);
        }
        // If we have consigne data but no correction_dp, use consigne
        else if (consigne.length > 0) {
            const wordsFromConsigne = consigne.map((word, wordIndex) => ({
                id: Date.now() + wordIndex,
                target: word,
            }));
            setWords(wordsFromConsigne);
            form.setFieldValue(`epreuves.${index}.words`, wordsFromConsigne);
        }
    }, [form.values.epreuves[index]?.correction_dp, form.values.epreuves[index]?.consigne, form.values.epreuves[index]?.words]);

    const addWord = () => {
        const newWord = {
            id: Date.now(),
            target: "",
        };
        const updatedWords = [...words, newWord];
        setWords(updatedWords);
        form.setFieldValue(`epreuves.${index}.words`, updatedWords);
        // Update both consigne and correction_dp with all targets
        const targets = updatedWords.map(word => word.target).filter(target => target.trim() !== '');
        form.setFieldValue(`epreuves.${index}.correction_dp`, targets);
        form.setFieldValue(`epreuves.${index}.consigne`, targets);
    };

    const removeWord = (wordId) => {
        const updatedWords = words.filter(word => word.id !== wordId);
        setWords(updatedWords);
        form.setFieldValue(`epreuves.${index}.words`, updatedWords);
        // Update both consigne and correction_dp with remaining targets
        const targets = updatedWords.map(word => word.target).filter(target => target.trim() !== '');
        form.setFieldValue(`epreuves.${index}.correction_dp`, targets);
        form.setFieldValue(`epreuves.${index}.consigne`, targets);
    };

    const updateWord = (wordId, value) => {
        const updatedWords = words.map(word =>
            word.id === wordId ? { ...word, target: value } : word
        );
        setWords(updatedWords);
        form.setFieldValue(`epreuves.${index}.words`, updatedWords);
        // Update both consigne and correction_dp with all targets
        const targets = updatedWords.map(word => word.target).filter(target => target.trim() !== '');
        form.setFieldValue(`epreuves.${index}.correction_dp`, targets);
        form.setFieldValue(`epreuves.${index}.consigne`, targets);
    };

    return (
        <Paper mb={20} p={10} shadow="xs">
            <Group noWrap position="apart">
                <Box style={{ flex: 1 }}>
                    <TextInput
                        label="Titre de l'exercice"
                        placeholder="Ex: Transcription mot par mot"
                        {...form.getInputProps(`epreuves.${index}.titre`)}
                        mb={10}
                    />

                    <Text size="sm" mb={10} color="dimmed">
                        Ajoutez les mots à transcrire
                    </Text>

                    <Group spacing="xs" mb={10} wrap>
                        {words.map((word, wordIndex) => (
                            <Group key={word.id} spacing="xs" align="center">
                                <Text size="sm" weight={500}>
                                    {wordIndex + 1}.
                                </Text>
                                <TextInput
                                    placeholder="Mot"
                                    value={word.target}
                                    onChange={(e) => updateWord(word.id, e.target.value)}
                                    size="sm"
                                    style={{ width: '120px' }}
                                />
                                <ActionIcon
                                    color="red"
                                    size="sm"
                                    onClick={() => removeWord(word.id)}
                                >
                                    <X size="1rem" />
                                </ActionIcon>
                            </Group>
                        ))}
                    </Group>

                    <Button
                        leftIcon={<Plus size={16} />}
                        variant="outline"
                        onClick={addWord}
                        size="sm"
                    >
                        Ajouter un mot
                    </Button>
                </Box>
                <ActionIcon
                    color="red"
                    onClick={() => form.removeListItem('epreuves', index)}
                >
                    <X size="1rem" />
                </ActionIcon>
            </Group>
        </Paper>
    );
}

export default WordByWordTranscriptionForm; 